$(document).ready(function(){
    $('body').on("click", "#add_nomination", function(){
       $('.hover_bkgr_fricc').show();
    });
    function get_cart(){
      $.get("/cart?view=ajax_side_cart", function(data, status){
               $(".cart-drawer__items").html(data);
               $('.qty-select').removeClass('sm:hidden');
             });
    }
      $('body').on('change', 'input[name="properties[Pack links separately]"]', function(){
                var ID = 39969146798126;
                if ($(this).is(':checked')) {
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {
                    quantity: 1,
                    id: ID
                  },
                 dataType: 'json',
                 success: function (data) {
                     if($('body').hasClass('template-cart')){
                       window.location.reload();
                     }else{
                       get_cart();
                     }
            }
            });
    
                }else{
              $.ajax({
                   type: 'POST',
                   url: '/cart/change.js',
                   dataType: 'json',
                   data: {
                       quantity: 0,
                       id: ID
                   },
                   success: function (data){
                     if($('body').hasClass('template-cart')){
                       window.location.reload();
                     }else{
                       get_cart();
                     }
                   }
              });
                }
              });
      $('body').on('change', 'input[name="properties[assemble my bracelet for me]"]', function(){
             var ID = 39968325206062;
          if ($(this).is(':checked')) {
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: ID
            },
           dataType: 'json',
           success: function (data) {
               if($('body').hasClass('template-cart')){
                 window.location.reload();
               }else{
                 get_cart();
               }
      }
      });
          }else{
        $.ajax({
             type: 'POST',
             url: '/cart/change.js',
             dataType: 'json',
             data: {
                 quantity: 0,
                 id: ID
             },
             success: function (data){
               if($('body').hasClass('template-cart')){
                 window.location.reload();
               }else{
                get_cart();
               }
             }
        });
          }
        });
      $('body').on('blur', 'input[name="Order of links"]', function(){
          var line = $(this).data('line');
          var vl = $(this).val();
        jQuery.post('/cart/change.js', {
            line: line,
            properties: {
          'Order of links': vl
            }
        });
      });



  $('body').on('click', '.nmbase-minus .minus, .nmbase-minus .remove-atc', function(e) {
    console.log("click")
    e.preventDefault(); // Prevent default page reload

    var minusCount = $('.nmbase-minus .minus').length;
    if (minusCount !== 1) {
      console.log('Multiple main items in cart. Skipping assemble removal.');
      return;
    }
    
    var $mainRow = $(this).closest('tr.nmbase'); 
    var mainLineInput = $mainRow.find('input.quantity-selector__input');
    var mainLineKey = mainLineInput.data('line-key');

    // Remove main product via AJAX
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: { quantity: 0, id: mainLineKey },
        dataType: 'json',
        success: function(cart) {
          console.log('Main item removed');

          // Remove assemble items via AJAX if they exist
          var $assembleItems = $('.nmbase-assemble input.quantity-selector__input');
          if ($assembleItems.length) {
              $assembleItems.each(function() {
                  var assembleLineKey = $(this).data('line-key');
                  console.log('Removing assemble item:', assembleLineKey);

                  $.ajax({
                      type: 'POST',
                      url: '/cart/change.js',
                      data: { quantity: 0, id: assembleLineKey },
                      dataType: 'json',
                      success: function() {
                          console.log('Assemble item removed:', assembleLineKey);
                          location.reload(); // Reload after removal
                      },
                      error: function(err) {
                          console.error('Error removing assemble item:', err);
                      }
                  });
              });
          } else {
              console.log('No assemble items found.');
                  location.reload();
          }
        },
        error: function(err) {
            console.error('Error removing main item:', err);
        }
    });
  });

  $('body').on('click', '.nmlink-minus .minus, .nmlink-minus .remove-atc', function(e) {
      e.preventDefault();

      var minusCount = $('.nmlink-minus .minus').length;
      if (minusCount > 2) return;
      var $mainRow = $(this).closest('tr.nmlink');
      var mainKey = $mainRow.find('.quantity-selector__input').data('line-key');
      console.log("Main Key:", mainKey);

      $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: {
              id: mainKey,
              quantity: 0
          },
          dataType: 'json',
          success: function() {
              var $assembleItems = $('.nmlink-remove .quantity-selector__input');
              if ($assembleItems.length) {
                  var requests = [];
                  $assembleItems.each(function() {
                      var assembleKey = $(this).data('line-key');
                      requests.push(
                          $.ajax({
                              type: 'POST',
                              url: '/cart/change.js',
                              data: {
                                  id: assembleKey,
                                  quantity: 0
                              },
                              dataType: 'json'
                          })
                      );
                  });
                  $.when.apply($, requests).done(function(){
                      location.reload();
                  });
              } else {
                  location.reload();
              }
          },
          error:function(err){
              console.log(err);
          }
      });
  });

});

$(document).ready(function () {

  function removeCartItems() {
    console.log("calledd")

    var minusCount = $('tr.nmlink').not('.nmbase').length;
    // console.log("minusCount", minusCount);

    if (minusCount != 0) return;

    var $mainRow = $('tr.nmlink').not('.nmbase').first();
    var qty = parseInt($mainRow.find('input.quantity-selector__input').val(), 10) || 0;

    // console.log("qty", qty);

    if (qty > 1) return;

    var $orgRows = $('tr.nmbase');
    var updates = {};

    $orgRows.each(function () {
      var orgLineInput = $(this).find('input.quantity-selector__input');
      var orgLineKey = orgLineInput.data('line-key');

      if (!orgLineKey) return;

      updates[orgLineKey] = 0;
    });

    // console.log("updates object:", updates);

    if (Object.keys(updates).length === 0) return;

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {
        updates: updates,
        sections: ['template--15455413076014__main']
      },
      dataType: 'json',
      success: function (response) {
        console.log("response updated:", response);
        // location.reload();
        if (response.sections && response.sections['template--15455413076014__main']) {
          $('#shopify-section-template--15455413076014__main')
            .html(response.sections['template--15455413076014__main']);
        }
      },
      error: function (err) {
        console.error('Error updating cart:', err);
      }
    });
  }

  if (window.location.pathname === '/cart') {
    removeCartItems();
  }

});

document.addEventListener("cart-drawer:refreshed", function (event) {
  let nmlinks = Array.from(document.querySelectorAll('line-item.nmlink:not(.nmbase)'));
  let nmbases = document.querySelectorAll('line-item.nmbase');

  nmbases.forEach(nmbase => {
    let baseId = nmbase.dataset.productId;
    let hasMatch = nmlinks.some(link => link.dataset.productId === baseId);

    if (!hasMatch) {
      let removeButton = nmbase.querySelector('.remove-atc');

      if (removeButton) {
        removeButton.click();
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", (event) => {
  let nmlinks = Array.from(document.querySelectorAll('line-item.nmlink'));
  let nmbases = document.querySelectorAll('line-item.nmbase');

  nmbases.forEach(nmbase => {
    let baseId = nmbase.dataset.productId;
    let hasMatch = nmlinks.some(nmlink => {
      return nmlink.dataset.productId === baseId
    });
    if (!hasMatch) {
      let quantitySelector = nmbase.querySelector('quantity-selector');
      if (quantitySelector) {
        let removeButton = quantitySelector.nextElementSibling;
        if (removeButton && removeButton.tagName === 'A') {
          removeButton.click();
        }
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
    const nmlinkss = document.querySelectorAll('line-item.assemble');
    const nmbasess = document.querySelectorAll('line-item.linkbox');

    // Proceed only if both exist
    if (nmlinkss.length > 0 && nmbasess.length > 0) {
        nmbasess.forEach(nmbase => {
            const removeButton = nmbase.querySelector('.remove-pack-link');
            if (removeButton) {
                removeButton.click();
            }
        });
    }
});


window.addEventListener('scroll', function () {
  if (window.scrollY > 0) {
    document.documentElement.classList.add('scrolled');
  } else {
    document.documentElement.classList.remove('scrolled');
  }
});

//Prevent double initialization globally
if (!window.paginationScriptInitialized) {
  window.paginationScriptInitialized = true;

  document.addEventListener("DOMContentLoaded", function () {
    const dropdowns = document.querySelectorAll(".custom-pagination-dropdown");
    if (!dropdowns.length) return;

    // ✅ Track if pagination already updated in this session
    if (!window.paginationUpdated) window.paginationUpdated = false;

    // ✅ Initialize dropdown functionality
    dropdowns.forEach(dropdown => {
      const toggle = dropdown.querySelector(".dropdown-toggle");
      const menu = dropdown.querySelector(".dropdown-menu");
      const items = dropdown.querySelectorAll(".dropdown-item");
      const currentDisplay = dropdown.querySelector("#currentPaginate");

      // Toggle dropdown visibility
      toggle.addEventListener("click", e => {
        e.stopPropagation();
        menu.classList.toggle("show");
        toggle.classList.toggle("open");
      });

      // Handle item selection
      items.forEach(item => {
        item.addEventListener("click", function () {
          const value = this.dataset.value;
          currentDisplay.textContent = value;
          menu.classList.remove("show");
          toggle.classList.remove("open");

          updatePagination(value);
        });
      });
    });

    // ✅ Close dropdown when clicking outside
    document.addEventListener("click", function () {
      document.querySelectorAll(".dropdown-menu.show").forEach(menu => menu.classList.remove("show"));
      document.querySelectorAll(".dropdown-toggle.open").forEach(btn => btn.classList.remove("open"));
    });

    // ✅ Common function for AJAX update
    function updatePagination(value) {
      if (window.paginationUpdated) return; // prevent double AJAX
      window.paginationUpdated = true;

      const finalValue = value !== "All" ? parseInt(value, 10) : value;

      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        dataType: "json",
        data: JSON.stringify({
          attributes: { pagination: finalValue }
        }),
        success: function () {
          console.log("Pagination updated:", finalValue);
          window.location.reload();
        },
        error: function (xhr) {
          console.error("Pagination update failed:", xhr.responseText);
          window.paginationUpdated = false; // allow retry
        }
      });
    }
  });
}


document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.querySelector('.product-gallery__carousel');
  const zoomBtn = document.querySelector('.product-gallery__zoom-button');

  if (carousel && zoomBtn) {
    carousel.addEventListener('click', function() {
      zoomBtn.click();
    });
  }
});


// Listen on document for events that bubble out from shadow DOM
document.addEventListener('change', function(e) {
  const path = e.composedPath();
  const insidePopover = path.some(el => el.tagName === 'X-POPOVER');
  let input = null;
  if (e.target.type === 'radio' && insidePopover) {
    const selectedValue = e.target.value;
    const selectedSize = e.target.nextElementSibling?.textContent?.trim();
   const variantOption =  e.target.closest('.variant-picker__option') || input.getRootNode().host?.closest('.variant-picker__option');
    console.log('Selected Value:', selectedValue);
    console.log('Selected Size:', selectedSize);
   if (variantOption) {
    const button = variantOption.querySelector('button.select span');
    if (button) {
      button.textContent = selectedSize;
    }
  }

    const form = e.target.closest('product-card');
    console.log(form);
    if (form) {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) {
        idInput.value = selectedValue;
        console.log("Updated input[name='id'] value to:", selectedValue);
      }
    }
  }
}, true); 
// document.addEventListener("change", function(e) {
//   let target = e.target;
//   let input = null;

//   if (target.matches('.popover__value-list input[type="radio"]')) {
//     input = target;
//   } else if (target.getRootNode() instanceof ShadowRoot) {
//     const shadowRoot = target.getRootNode();
//     input = shadowRoot.querySelector('.popover__value-list input[type="radio"]:checked');
//   }

//   if (!input) return;

//   const labelEl = input.closest('label');
//   const selectedLabel = labelEl ? labelEl.querySelector('span')?.textContent.trim() : '';
//   const selectedValue = input.value;

//   console.log("Selected Input Value:", selectedValue);
//   console.log("Selected Size:", selectedLabel);

//   const variantOption = input.closest('.variant-picker__option') 
//     || input.getRootNode().host?.closest('.variant-picker__option');

//   if (variantOption) {
//     const button = variantOption.querySelector('button.select span');
//     if (button) {
//       button.textContent = selectedLabel;
//     }
//   }

//   const form = input.closest('form');
//   console.log(form);
//   if (form) {
//     const idInput = form.querySelector('input[name="id"]');
//     if (idInput) {
//       idInput.value = selectedValue;
//       console.log("Updated input[name='id'] value to:", selectedValue);
//     }
//   }
// });



// (function () {
//   fetch('/cart.js')
//     .then(res => res.json())
//     .then(cart => {
//       console.log("called")
      
//       if (cart.items.length === 1) {
//         console.log("cart.items.length", cart.items.length)

//         let item = cart.items[0];
//         console.log("item.sku", item.sku)

//         if (item.sku === '030000-SI-13') {

//           fetch('/cart/change.js', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json'
//             },
//             body: JSON.stringify({
//               id: item.key,
//               quantity: 0
//             })
//           })
//           .then(res => res.json())
//           .then(data => {
//             console.log('Item removed', data);
//             location.reload(); 
//           });

//         }
//       }
//     });
// })();









// v-stack justify-items-center gap-2   nmbase-minus   nmlink-minus 